import { MainLayout } from '@/components/layout/MainLayout';
import { Button } from '@/components/ui/button';
import { Button3D } from '@/components/ui/button-3d';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { useCompany } from '@/contexts/useCompany';
import { useRole } from '@/hooks/useRole';
import { CompanyMembersPanel } from '@/components/team/CompanyMembersPanel';
import { ArrowLeft, Users, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function TeamPage() {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const { activeCompany } = useCompany();
  const { canManageTeam } = useRole();

  // Require login.
  if (!authLoading && !user) {
    return (
      <MainLayout showFab={false}>
        <div className="flex flex-col items-center justify-center py-16 text-center space-y-4">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted">
            <Lock className="h-8 w-8 text-muted-foreground" />
          </div>
          <div className="space-y-2">
            <h2 className="text-xl font-semibold">Faça login</h2>
            <p className="max-w-sm text-sm text-muted-foreground">
              Você precisa estar logado para gerenciar sua equipe.
            </p>
          </div>
          <Button3D onClick={() => navigate('/auth')}>Fazer login</Button3D>
        </div>
      </MainLayout>
    );
  }

  // Only owner/admin manage the team. Members/viewers get a clear message.
  if (!canManageTeam) {
    return (
      <MainLayout showFab={false}>
        <div className="flex flex-col items-center justify-center py-16 text-center space-y-4">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted">
            <Users className="h-8 w-8 text-muted-foreground" />
          </div>
          <div className="space-y-2">
            <h2 className="text-xl font-semibold">Acesso restrito</h2>
            <p className="max-w-sm text-sm text-muted-foreground">
              A gestão de equipe está disponível apenas para o dono e administradores
              desta empresa.
            </p>
          </div>
          <Button variant="outline" onClick={() => navigate('/dashboard')}>
            Voltar ao início
          </Button>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout showFab={false}>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div className="flex-1">
            <h1 className="flex items-center gap-2 text-xl font-bold">
              <Users className="h-6 w-6 text-primary" />
              Equipe
            </h1>
            {activeCompany && (
              <p className="text-sm text-muted-foreground">{activeCompany.name}</p>
            )}
          </div>
        </div>

        {/* Intro */}
        <Card className="border-primary/20 bg-primary/5">
          <CardContent className="pt-4">
            <p className="text-sm text-muted-foreground">
              Convide pessoas para colaborar nesta empresa. Cada membro entra com um cargo
              que define o que pode ver e editar — todos compartilham os mesmos orçamentos,
              clientes e catálogo.
            </p>
          </CardContent>
        </Card>

        <CompanyMembersPanel />
      </div>
    </MainLayout>
  );
}
